import { render } from "./message-transfer-with-desc.vue?vue&type=template&id=502cc174&scoped=true&ts=true"
import script from "./message-transfer-with-desc.vue?vue&type=script&lang=ts"
export * from "./message-transfer-with-desc.vue?vue&type=script&lang=ts"

import "./message-transfer-with-desc.vue?vue&type=style&index=0&id=502cc174&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-502cc174"]])

export default __exports__